import {useEffect} from 'react';

import { Link } from 'react-router-dom';
import FamilyReunion from './FamilyReunion';
import LegalizationDocuments from './LegalizationDocuments';
import NationalityVisa from './NationalityVisa';
import StudyVisa from './StudyVisa';

const Visatronix = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);   
  
    return(
        <div>
            <div id='international' className="visatronix-image">
                <img src='/new-image/visatronix.jpg' alt='' className='w-[100%]'/>
            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[50px]  pb-[1rem]">
                <p>
                    TCS Visatronix provides a hassle-free, one window, visa dropbox and value-added visa facilitation 
                    services. Operating from eleven major cities of Pakistan, with a dedicated team of courteous and 
                    experienced visa services officers, we manage over 100,000 visa applications annually.
                </p>
                <p>
                    Fully equipped with Quality Management System for efficient and secure handling of applications, 
                    documents and managing queues without the involvement of any third-party at any stage of the process, 
                    our Visa Application Centres are guarded round the clock. Applicants’ waiting lounges are furnished 
                    with comfortable seating and television screens, with dedicated counters for senior citizens and the 
                    people with special needs. Document scanning, photocopying, faxing, printing, emailing and biometric 
                    data verification facilities are all provided under one roof. Applicants are kept informed about 
                    their application status through SMS alerts, whereas our helplines provide further assistance.
                </p>
                
                <div className="MuiFormGroup-root MuiFormGroup-row">
                    <div className="lg:flex grid pb-[50px]">
                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center ">
                                <li><Link to="/vistronix/legalization"  className='font-bold'>Legalisation / Attestations of Documents</Link></li>
                            </div>

                            <div className="flex items-center">
                                <li><Link to="/visatronix/study-visa" className='font-bold'>Study/Medical Visa Applications</Link></li>
                            </div>
                        </div>

                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center">
                                <li><Link to="/visatronix/nationality-visa" className='font-bold'>Immigration Visa Applications</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/vistronix/family-reunion" className='font-bold'>Family Reunion (immigration cases)</Link></li>
                            </div>
                        </div>
                            
                    </div>
                </div> 
                
                 
            </div>
            <div className='mx-[2rem] md:mx-[0rem]'>
            
            <div id="legalization">
                <LegalizationDocuments/>
            </div>
            <div id="nationality-visa">
                <NationalityVisa />
            </div>
            <div id="study-visa">
                <StudyVisa />
            </div>
            <div id="family-reunion">
                <FamilyReunion/>
            </div> 

            </div>

        </div>
    )
};
export default Visatronix;